export class SchemaModel {
    constructor(schema) {
        this.properties = Object.values(schema);
    }
    getKeys(predicate = () => true) {
        return this.properties.filter(predicate).map((prop) => prop.key);
    }
    pick(obj, predicate) {
        return this.getKeys(predicate).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: obj[key] })), {});
    }
}
//# sourceMappingURL=SchemaModel.js.map